<template>
  <!--  会员支付成功弹窗  -->
  <PayVipSuccess ref="payVipSuccess" @success="handleVipPaySuccess"/>
  <!--  金币购买成功弹窗  -->
  <CoinsBuySuccess ref="coinsBuySuccess" :extra-data="extraData"/>
  <!--  金币购买挽留弹窗  -->
  <SpecialOffer ref="specialOffer" @handle-pay="open" @close="close"/>
  <!--  会员充值挽留  -->
  <RechargePopup ref="rechargePopup" @open-pay-popup="open" @close="close"/>
  <!--  支付弹窗  -->
  <PayPopup
ref="payPopup" :current-product="data.product" :payment-type="data.paymentType"
            :extra="props.extra"/>
  <!--  取消支付弹窗  -->
  <RechargeFailed ref="rechargeFailed"/>
</template>

<script setup lang="ts">
import PayVipSuccess from '~/components/paySuccessful/index.vue'
import CoinsBuySuccess from '~/components/paySuccessful/PurchaseCoins.vue'
import {ref, nextTick, onBeforeUnmount} from "vue";
import eventBus from '../../utils/eventBus'

const emit = defineEmits(['close', 'vipPaySuccess'])
const payVipSuccess = ref(null)
const coinsBuySuccess = ref(null)
const specialOffer = ref(null)
const rechargePopup = ref(null)
const extraData = ref(null)
const payPopup = ref(null)
const rechargeFailed = ref(null)
const route = useRoute()
const props = defineProps({
  extra: {
    type: Object,
    default: () => ({})
  }
})
const data = reactive({
  paymentType: '',
  product: {},
  needDiscountTicket: false
})

// 关闭挽留弹窗事件，控制弹下一个
const close = () =>{
  emit('close')
}

const open = (type, payload = {}) => {
  console.log('type', type)
  console.log('payload', payload)
  extraData.value = payload
  switch (type) {
    case 'PayVipSuccess':
      // VIP购买成功弹窗
      payVipSuccess.value?.open()
      break;
    case 'CoinsBuySuccess':
      // 金币购买成功弹窗
      coinsBuySuccess.value?.open(payload)
      break;
    case 'SpecialOffer':
      // 金币购买挽留弹窗
      specialOffer.value?.open(payload)
      break;
    case 'RechargePopup':
      // 会员充值挽留弹窗
      rechargePopup.value?.open(payload)
      break;
    case 'PayPopup':
      // 支付弹窗
      console.log('extraData', payload)
      data.product = payload
      data.paymentType = payload?.product_type === 1 ? 'order' : 'subscription'
      payPopup.value?.open()
      break;
    case 'RechargeFailed':
      // 取消支付弹窗
      rechargeFailed.value?.open()
      break;
    default:
      break;
  }
}

// 落地页vip订阅成功通知父组件去跳转到阅读页
const handleVipPaySuccess = () =>{
  if(route.path !=='/ads') return
  console.log(route)
  emit('vipPaySuccess')
}

// SDK 脚本提前加载：不 await，与渠道/商品列表请求并行，把跨洋 CDN 下载移出预热关键路径
// （内部有 window.PMdropin 单例判断 + SSR 保护，重复调用无副作用）
usePaymentPreload().loadPayermaxSdk()

// 预渲染：productsPopup / vip 拿到默认商品后广播，这里先把商品 + 类型灌进来（与 open('PayPopup') 里赋值一致，
// 保证 pay-popup 拿到正确的 currentProduct/paymentType，session 才不会分错桶），
// 再经 ref 调 pay-popup.preRender 把 SDK 按钮挂到常驻弹窗 DOM 里，用户打开时即用、无 loading 不闪。
// 具名 handler + 卸载时 off，避免页面切换后旧实例监听器残留
const handleWarmPayPopup = async (product) => {
  if (!product?.rsp_id) return
  data.product = product
  data.paymentType = product?.product_type === 1 ? 'order' : 'subscription'
  await nextTick()
  payPopup.value?.preRender()
}
eventBus.on('warmPayPopup', handleWarmPayPopup)
onBeforeUnmount(() => {
  eventBus.off('warmPayPopup', handleWarmPayPopup)
})

defineExpose({
  open
})

</script>

<style scoped lang="scss">
.popup_handle {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
}
</style>
